import { useMemo, useEffect } from "react";
import { withQueryParams } from "../../appointment-details/helpers/common.js";
import { useLocalStorageProperly } from "../../../../hooks/useLocalStorageProperly.js";
import { useQuery } from "@tanstack/react-query";
import { useAxiosProvider } from "../components/AxiosProvider.js";
import { initialPractitionersSelector } from "../patient-today-list-container.selectors.js";
import "date-fns";
import "date-fns/locale";
import "../../appointment-details/appointment-details.types.js";
import "react/jsx-runtime";
import "axios";
import "../helpers.js";
import "libphonenumber-js/mobile";
import "../types/practitioner.js";
const getPractitioners = (axios) => async (params) => {
  const { data } = await axios.get("/api/practitioners", { params });
  return data;
};
const usePractitioners = (params, auth, baseURL) => {
  const { calmaster } = useAxiosProvider();
  const queryKey = useMemo(() => ["practitioners", params], [params]);
  const enabled = !!auth && !!baseURL;
  const { data, isSuccess, isFetching } = useQuery({
    queryKey,
    queryFn: withQueryParams(getPractitioners(calmaster)),
    enabled,
    keepPreviousData: true
  });
  const [practitioners, setPractitioners] = useLocalStorageProperly(
    `${params.clinicReferenceId}_practitioners`,
    []
  );
  useEffect(() => {
    const shouldSetPractitioners = (data == null ? void 0 : data.length) && isSuccess && !isFetching && !(practitioners == null ? void 0 : practitioners.length);
    if (shouldSetPractitioners) {
      setPractitioners(initialPractitionersSelector(data));
    }
  }, [data, isSuccess, isFetching, params.clinicReferenceId, setPractitioners, practitioners]);
  return {
    practitioners,
    setPractitioners
  };
};
export {
  usePractitioners
};
